import React from 'react'
import { FilterName, FilterParam } from '../FilterBar.types'
import { GenericFilterDropdown } from './GenericFilterDropdown'

export const AuditRunControlFilterDropdown = React.memo(
  ({ isNested = false }: { isNested?: boolean }): JSX.Element => {
    return (
      <GenericFilterDropdown
        filterParam={FilterParam.AUDIT_RUN_CONTROL}
        filterName={FilterName.AUDIT_RUN_CONTROL}
        valueKey="auditRunControls"
        isNested={isNested}
      />
    )
  },
)
